module.exports = __webpack_public_path__ + "img/gltf.35d10ab7.png";